import BaseComponent from '../../../js/base-component'
import { Splide } from '@splidejs/splide/build/complete/complete';

class EventSlider extends BaseComponent {
    constructor(options) {
        super(options);
    }

    onInit() {
        const eventSliderContainer = this.element.querySelector('.u-event-slider__slider');

        if (eventSliderContainer) {
            this.splide = new Splide(eventSliderContainer, {
                pagination: false,
                perPage: 3,
                perMove: 1,
                gap: "1rem",
                breakpoints: {
                    767: {
                        arrows: false,
                        pagination: true,
                        perPage: 1,
                        perMove: 1,
                    },
                    1023: {
                        arrows: true,
                        pagination: true,
                        perPage: 2,
                        perMove: 1,
                        gap: "1rem",
                    },
                },
            });

            this.splide.mount();
        }
    }
}

export default {
  name: 'EventSlider',
  definition: EventSlider
};